import type { PickAnalyticsEventAttributes } from '../../../../types'
import { analyticsEvents } from '../../integration/analytics-multiplatform-sdk'

export const AddressCheck = (attributes: PickAnalyticsEventAttributes<'AddressCheck'>) => {
  const { AddressCheck, AddressCheckType } = analyticsEvents

  return new AddressCheck(
    attributes.coordinatesLatitude,
    attributes.coordinatesLongitude,
    attributes.addressStatusSuccessful,
    AddressCheckType[attributes.checkType],
    attributes.query,
    attributes.generatedAddress
  )
}

export const AddressCreationSucceeded = (
  attributes: PickAnalyticsEventAttributes<'AddressCreationSucceeded'>
) => {
  const {
    AddressCreationSucceeded,
    AddressSearchSource,
    AddressType,
    AddressSource,
    AddressDetailsSource,
  } = analyticsEvents

  return new AddressCreationSucceeded(
    AddressType[attributes.addressType],
    AddressSource[attributes.source],
    null, // historicAddress
    null, // mapUsed
    null, // addressNotes
    attributes.isGpsEnabled,
    attributes.isAddressRefined,
    attributes.coordinatesLatitude,
    attributes.coordinatesLongitude,
    attributes.addressLine,
    AddressSearchSource[attributes.entrySource],
    AddressDetailsSource[attributes.addressSource],
    attributes.addressId,
    attributes.isStreetNameMissing,
    attributes.isStreetNumberMissing,
    attributes.isFloorMissing,
    attributes.isDoorMissing,
    attributes.isAdditionalInformationMissing,
    attributes.addressLabel,
    attributes.addressKind
  )
}

export const AddressDetails = (attributes: PickAnalyticsEventAttributes<'AddressDetails'>) => {
  const { AddressDetails, AddressDetailsSource } = analyticsEvents

  return new AddressDetails(
    AddressDetailsSource[attributes.addressDetailsSource],
    attributes.addressKind,
    attributes.isAddressFaulty,
    attributes.addressLine,
    attributes.coordinatesLatitude,
    attributes.coordinatesLongitude
  )
}

export const AddressFlowLandingScreen = (
  attributes: PickAnalyticsEventAttributes<'AddressFlowLandingScreen'>
) => {
  const { AddressFlowLandingScreen, AddressSearchSource } = analyticsEvents

  return new AddressFlowLandingScreen(
    AddressSearchSource[attributes.source],
    attributes.isGpsEnabled,
    attributes.categoryId
  )
}

export const AddressLandingOptionClicked = (
  attributes: PickAnalyticsEventAttributes<'AddressLandingOptionClicked'>
) => {
  const { AddressLandingOptionClicked, AddressSearchSource, AddressLandingOption } = analyticsEvents

  return new AddressLandingOptionClicked(
    AddressLandingOption[attributes.addressOption],
    AddressSearchSource[attributes.source]
  )
}
